import { client } from '../libs/client';
import { event } from '../types/cms-types';

export interface CategorizedEvents {
  特別企画: event[];
  ステージ: event[];
  'サークル/有志': event[];
  その他: event[];
  '11/2': event[];
  '11/3': event[];
}

export const fetchAllEvents = async (): Promise<event<'gets'>> => {
  return client.get({
    endpoint: 'event',
    queries: { limit: 100 },
  });
};

export const fetchEventById = async (id: string, draftKey?: string): Promise<event | null> => {
  try {
    const response = await client.get({
      endpoint: 'event',
      contentId: id,
      queries: draftKey ? { draftKey } : undefined,
    });
    return response as event;
  } catch (error) {
    console.error('イベント詳細の取得に失敗しました:', error);
    return null;
  }
};

export const categorizeEvents = (events: event[]): CategorizedEvents => {
  const categorizedEvents: CategorizedEvents = {
    特別企画: [],
    ステージ: [],
    'サークル/有志': [],
    その他: [],
    '11/2': [],
    '11/3': [],
  };

  events.forEach((event) => {
    event.event_category.forEach((category) => {
      if (category in categorizedEvents) {
        if (event.event_top) {
          categorizedEvents[category].unshift(event);
        } else {
          categorizedEvents[category].push(event);
        }
      }
    });

    event.event_day.forEach((day) => {
      if (day in categorizedEvents) {
        if (event.event_top) {
          categorizedEvents[day].unshift(event);
        } else {
          categorizedEvents[day].push(event);
        }
      }
    });
  });

  return categorizedEvents;
};

export const fetchAndCategorizeEvents = async (): Promise<CategorizedEvents> => {
  const response = await fetchAllEvents();
  return categorizeEvents(response.contents);
};

// タイムテーブル用のイベントを取得（event_scheduleまたはevent_timetableが存在するもののみ）
export const fetchTimetableEvents = async (): Promise<event[]> => {
  const response = await fetchAllEvents();
  return response.contents.filter((event) => event.event_schedule?.length || event.event_timetable);
};
